import React from "react"
import { Link } from "gatsby"

export default function ButtonPrimary(props) {
    return (
        <Link to={props.buttonLink} className="button--primary" style={{color:`#fff`,textDecoration:`none`}}>{props.buttonText}</Link>
    )
}